var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-popup",attrs:{"id":"modal_popup_nps"}},[_c('div',{staticClass:"modal-popup-content"},[_c('a',{staticClass:"close-button",on:{"click":_vm.closeNps}},[_c('img',{attrs:{"src":require("@/assets/images/close-button.svg")}})]),_c('LinkFrame',{attrs:{"documentContent":this.notification.content}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }